<template>
  <div class="products-display">
    <Title :title="title" />
    <ProductsLayout
      :forceDisplayProducts="displayedProducts"
      :forceLoading="isLoading"
      :prefix="prefix"
      :featuredProducts="true"
      :isCarousel="true"
    />
  </div>
</template>

<style lang="scss" scoped>
.products-display {
  padding: 2rem 0;
}
</style>

<script>
import ProductsLayout from "@/layouts/archive/product-grid/ProductsLayout.vue";
import Title from "@/layouts/general-ui/Title.vue";

export default {
  name: "ProductsDisplay",
  components: {
    ProductsLayout,
    Title
  },
  data() {
    return {};
  },
  props: {
    isLoading: Boolean,
    products: Array,
    type: {
      type: String,
      default() {
        return "kaali";
      }
    },
    title: String,
    prefix: String,
    isCarousel: {
      type: Boolean,
      default() {
        return false;
      }
    },
  },
  computed: {
    displayedProducts() {
      if (this.products.length === 0) {
        return null;
      }
      return this.products;
    }
  }
};
</script>
